import { elements } from '../periodicElements';
import { Link, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { handleElementClick, renderElementVideo, renderColumn } from '../FunctionsElements';
import { useTranslation } from 'react-i18next';

export default function EnablingSystem() {
  const [selectedElement, setSelectedElement] = useState(null);
  const { t } = useTranslation(); 
  const navigate = useNavigate();
  
  return (
      <section>
        {selectedElement ? (
          <section className="bg-background-secondary min-h-screen flex flex-col items-center justify-center p-4 transition-colors duration-300">
            <div className="flex items-center justify-center w-full max-w-4xl">
              {renderElementVideo(selectedElement, setSelectedElement, t, navigate)}
            </div>
          </section>
          
        ) : (
          <section className="min-h-screen p-4 pt-28 pb-12 bg-background-secondary transition-colors duration-300">
            
            <div className="w-full max-w-7xl mx-auto flex justify-start mb-8 lg:px-8">
              <Link to="/TPQVS"> 
                <button className="btn-back">
                  <svg className="w-5 h-5 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                  </svg>
                  {t("elements.back")}
                </button>
              </Link>
            </div>

            <div className="flex flex-col lg:flex-row justify-center items-center lg:items-start w-full max-w-[90rem] mx-auto gap-10 lg:gap-16 px-2">
              
              <div className="w-full lg:w-1/2 overflow-x-auto overflow-y-hidden p-2 custom-scrollbar flex justify-center lg:justify-start lg:min-h-[500px] xl:min-h-[800px]">
                
                <div className="grid grid-cols-5 pl-14 ml-4 md:ml-16 lg:ml-4 gap-0 text-center w-fit min-w-max border-collapse lg:scale-125 xl:scale-[1.35] origin-top-left transition-transform duration-300">
                  {renderColumn(elements, 53, 59, false, 0, handleElementClick, setSelectedElement, false, false, false, true)}
                  {renderColumn(elements, 59, 65, false, 0, handleElementClick, setSelectedElement, false, false, false, true)}
                  {renderColumn(elements, 65, 71, false, 0, handleElementClick, setSelectedElement, false, false, false, true)}
                  {renderColumn(elements, 71, 77, false, 0, handleElementClick, setSelectedElement, false, false, false, true)}
                  {renderColumn(elements, 77, 83, false, 0, handleElementClick, setSelectedElement, false, false, false, true)}
                </div>
              </div>
 
              <div className="w-full lg:w-1/2 p-6 bg-surface border border-border-light rounded-2xl shadow-card transition-colors duration-300 mt-4 lg:mt-0">
                <h2 className="text-xl md:text-2xl font-bold text-center mb-4 border-b-2 border-primary text-text-primary pb-2">
                  {t("ConditionsElements.name")} 
                </h2>
                <p className="text-sm md:text-base leading-relaxed text-justify text-text-secondary">
                  {t("ConditionsElements.discretion")}
                </p>
              </div>
              
            </div>
          </section>
        )}
      </section>
  );
}